/* sheesha directory pages — instant client-side search (Brands + News catalog). */
(function () {
  function setup(root) {
    var input = root.querySelector('[data-dir-search]');
    var grid = root.querySelector('[data-dir-grid]');
    var empty = root.querySelector('[data-dir-empty]');
    var count = root.querySelector('[data-dir-count]');
    if (!input || !grid) return;
    var cards = Array.prototype.slice.call(grid.children);
    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase();
      var shown = 0;
      cards.forEach(function (c) {
        var name = c.getAttribute('data-name') || '';
        var match = name.indexOf(q) !== -1;
        c.toggleAttribute('hidden', !match);
        if (match) shown++;
      });
      if (empty) empty.toggleAttribute('hidden', shown !== 0);
      if (count) count.textContent = shown + (shown === 1 ? ' result' : ' results');
    });
  }
  function init() { document.querySelectorAll('.sheesha-dir').forEach(setup); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
